import { render, staticRenderFns } from "./AllDatabases.vue?vue&type=template&id=1be7803a&"
import script from "./AllDatabases.vue?vue&type=script&lang=ts&"
export * from "./AllDatabases.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports